import { Component, OnInit ,EventEmitter,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../common.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-edit-admin',
  templateUrl: './edit-admin.component.html',
  styleUrls: ['./edit-admin.component.scss']
})
export class EditAdminComponent implements OnInit {
isEmited=new EventEmitter()
  editadmin: any;
  editdata:any;
  adminid: any;
  constructor(private dialogRef: MatDialogRef<EditAdminComponent>,@Inject(MAT_DIALOG_DATA) private data:any,private fb: FormBuilder,private snack:MatSnackBar,public service:CommonService,public dialog: MatDialog,private router: Router) { }

  ngOnInit(): void {
    this.CustomerEditForm();
this.editdata=this.data;
if (this.data.name) this.editadmin.controls.name.setValue(this.data.name)
if (this.data.phoneNo) this.editadmin.controls.phoneNo.setValue(this.data.phoneNo)
if (this.data.email) this.editadmin.controls.email.setValue(this.data.email)
  }
  closeDialog() {
    this.dialogRef.close();
  }
  CustomerEditForm() {
    this.editadmin = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phoneNo: ['', [Validators.required]],
    });
  }





  editprofile(){
    this.adminid =this.editdata._id
    let req ={
      "name" : this.editadmin.controls.name.value,
      "email" : this.editadmin.controls.email.value,
      "phoneNo"  : this.editadmin.controls.phoneNo.value,
    }
    this.service.editadmin(this.adminid,req).subscribe((data : any)=> {

      if(data.message == "Success"){
        this.snack.open("Edit successfully",'',{
          duration:1000,
         verticalPosition:'top',
         horizontalPosition: 'end',
        })
        this.dialogRef.close();
        this.isEmited.emit(true)
        // this.router.navigate(['/customer'])
      }else{
        this.editadmin.reset();
      }
  })
  }
}
